(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("thunderbolt", [], factory);
	else if(typeof exports === 'object')
		exports["thunderbolt"] = factory();
	else
		root["thunderbolt"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 